<template>
  <div
    :id="'question-submission-' + interaction(interactionId).id"
    class="file-viewer-wrapper"
  >
    <!-- Preview iframe of hosted PDF file: -->
    <div
      v-if="showFilePreview"
      :key="fileViewerKey"
      id="player-file-viewer-embedded-adobe-viewer-sdk"
      class="player-file-viewer-embedded-adobe-viewer-sdk-wrapper mb-2"
    >
      <div
        :id="pdfViewerIdentifier"
      >
        <!-- Inject PDF file to preview here! -->
      </div>
    </div>
  </div>
</template>

<script>
/* global _ */
/* global dataLayer */

// Core:
import {
  mapState,
  mapGetters,
  mapActions,
} from 'vuex';

import uuid from 'uuid/v4';

import EventBus from '@/buses/EventBus';

// Global Mixin(s):
import PdfViewer from '@mixins/PdfViewer/PdfViewer.js'

// Custom Helpers:
import {
  waitForElementToDisplay,
} from '@utilities';

export default {
  name: 'InteractionFileViewer',
  props: [
    'interactionId',
    'visible'
  ],
  mixins: [
    PdfViewer,
  ],
  data() {
    return {
      fileViewerKey: 0,
      initial: false,
      showFilePreview: false,
      viewerId: uuid(),
    };
  },
  computed: {
    ...mapState('player', [
      'isLiveSession',
      'liveSessionTimeArray',
      'liveSessionUnixTime',
    ]),
    ...mapGetters('player', [
      'bulbAttempt',
      'user',
      'userAgent',
    ]),
    ...mapGetters('interactions', [
      'interaction',
      'interactionAttempt',
      'interactionMeta',
    ]),
    interactionCountdown() {
      if (!this.isLiveSession) return 0;
      return Math.trunc(this.sessionInteraction.unixDisplayOutTime - this.liveSessionUnixTime,);
    },
    sessionInteraction() {
      return _.find(this.liveSessionTimeArray, {
        interactionId: this.interaction.id,
      });
    },
    pdfViewerIdentifier() {
      return `player-interaction-head-file-viewer-pdf-preview-${this.viewerId}`
    },
  },
  methods: {
    ...mapActions('interactions', [
      'submitAnswer'
    ]),
    initAnswer() {
      this.interactionAttempt(this.interactionId).responseText = ['file_viewer_placeholder'];
    },
    async previewPDF() {
      if (!this?.interaction(this?.interactionId)?.interactionText) return;
      
      this.showFilePreview = true;
      await this.$nextTick();
      const pdfPreviewDivElement = await waitForElementToDisplay(`#player-interaction-head-file-viewer-pdf-preview-${this.viewerId}`);
      if (!pdfPreviewDivElement) return;

      this.createAdobeViewerInstance({ divId: this.pdfViewerIdentifier });
      await this.previewFile({
        resourceLocationUrl: this.interaction(this.interactionId).interactionText,
      });
    },
  },
  watch: {
    async adobeViewerSDKScriptInjected(newValue, oldValue) {
      if (newValue) {
        await this.previewPDF();
      }
    },
    visible() {
      if (
        this.visible
        && !this.interactionMeta(this.interactionId).isInteractionAnswered
        && !this.isLiveSession
      ) {
        this.initAnswer();
        this.submitAnswer({
          interaction: this.interaction(this.interactionId),
          interactionAttempt: this.interactionAttempt(this.interactionId),
          interactionMeta: this.interactionMeta(this.interactionId),
        });
      }
    },
    interactionCountdown(newValue, oldValue) {
      /**
       * Reference `InteractionEmbed.vue` comment.
       */
      if (
        this.isLiveSession
        && newValue < 0
        && this.visible
        && !this.interactionMeta(this.interactionId).isInteractionAnswered
      ) {
        this.initAnswer();
        this.submitAnswer({
          interaction: this.interaction(this.interactionId),
          interactionAttempt: this.interactionAttempt(this.interactionId),
          interactionMeta: this.interactionMeta(this.interactionId),
        }).then(() => {
          EventBus.$emit('requestAction', {
            key: 'play',
            setDesiredState: true,
          });
        });
      }
    },
  },
};
</script>

<style lang="scss">

.player-file-viewer-embedded-adobe-viewer-sdk-wrapper {
  height: 100vh;
}

div[id^="player-interaction-head-file-viewer-pdf-preview-"] {
  ::v-deep iframe {
    pointer-events: auto;
  }
}

</style>
